import axios from 'axios';
import config from '../../config';

// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.baseURL = config.API_URL;

// interceptando para capturar erros
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        let message;
        if (error && error.response) {
            switch (error.response.status) {
                case 401:
                    message = 'Credenciais inválidas';
                    break;
                case 403:
                    window.location.href = '/access-denied';
                    break;
                case 404:
                    message = 'Desculpe! O dado que você procura não foi encontrado';
                    break;
                default:
                    message = error.response.data?.message || error.message || error;
            }
        }
        return Promise.reject(message);
    }
);

export const AUTH_SESSION_KEY = 'santa_casa_user';

const getUserFromSession = (): any => {
    const user = sessionStorage.getItem(AUTH_SESSION_KEY);
    return user ? JSON.parse(user) : null;
};

class APICore {
    create = (url: string, data: any) => {
        return axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    };    

    isUserAuthenticated = (): boolean => {
        const user = this.getLoggedInUser();
        return !!user; 
    };

    setLoggedInUser = (session: any) => {
        if (session) {
            sessionStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));
        } else {
            sessionStorage.removeItem(AUTH_SESSION_KEY);
        }
    };

    getLoggedInUser = (): any => getUserFromSession();
}

const login = async (username: string, password: string): Promise<any> => {
    try {
        const requestData = { username, password };
        console.log("Enviando requisição para:", "auth/login", "com dados:", requestData);

        const response = await axios.post('auth/login', requestData);
        const userData = response.data;

        new APICore().setLoggedInUser(userData);

        window.location.href = "/";

        return userData;
    } catch (error) {
        console.error("Erro ao realizar login:", error);
        throw error;
    }
};

export { APICore, login };
